<button
  guaranteesControl
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
  class="flex min-h-7 w-full min-w-0 items-center gap-1.5 pr-7 text-left"
  type="button"
  aria-haspopup="listbox"
  [attr.aria-expanded]="open()"
  [disabled]="disabled()"
  (click)="toggle()"
  (keydown)="onFieldKeydown($event)"
>
  @if (selected()?.icon; as icon) {
    <mat-icon class="h-4! w-4! shrink-0 text-base! leading-4! text-neutral-400">{{ icon }}</mat-icon>
  }

  <span
    class="min-w-0 flex-1"
    [class]="labelClass()"
    >{{ selected()?.label ?? placeholder() }}</span
  >
</button>

<span class="pointer-events-none absolute top-0 right-1 flex h-7 items-center">
  @if (clearable() && selected() && !disabled()) {
    <button
      class="pointer-events-auto inline-flex size-6 items-center justify-center rounded-full text-neutral-400 hover:bg-neutral-100 hover:text-neutral-700 focus-visible:ring-2 focus-visible:ring-primary-500/40 focus-visible:outline-none"
      type="button"
      tabindex="-1"
      [matTooltip]="'general.action.clear' | translate"
      (click)="clear()"
    >
      <mat-icon class="h-4! w-4! text-base! leading-4!">close</mat-icon>
    </button>
  } @else {
    <mat-icon class="h-4! w-4! text-base! leading-4! text-neutral-400">{{ open() ? "expand_less" : "expand_more" }}</mat-icon>
  }
</span>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="open()"
  [cdkConnectedOverlayPositions]="overlayPositions()"
  [cdkConnectedOverlayWidth]="panelWidth()"
  [cdkConnectedOverlayMatchWidth]="true"
  (overlayOutsideClick)="close()"
  (detach)="close()"
>
  <!-- The overlay pane is a flex row: content must be sized to the field explicitly or it takes its own width. -->
  <div
    class="flex min-w-0 flex-col"
    [style.width.px]="panelWidth() || null"
  >
    <!-- Covers the field it was opened from, so the picked value it stands in for is shown as a filled placeholder. -->
    @if (searchable()) {
      <guarantees-search-field
        class="rounded-md shadow-lg"
        name="optionSearch"
        [filled]="!!selected()"
        [placeholder]="selected()?.label ?? placeholder()"
        [value]="search()"
        (valueChange)="type($event)"
        (keydown)="onSearchKeydown($event)"
      ></guarantees-search-field>
    }

    <guarantees-option-list
      [maxHeight]="maxHeight()"
      [empty]="matches().length === 0"
      [emptyMessage]="emptyMessage()"
    >
      @for (option of matches(); track option.value; let index = $index) {
        <li>
          <button
            guaranteesOption
            type="button"
            [id]="rowId(index)"
            [class]="rowClass(option, index)"
            (click)="pick(option.value)"
          >
            @if (option.icon; as icon) {
              <mat-icon class="h-4! w-4! shrink-0 text-base! leading-4! text-neutral-400">{{ icon }}</mat-icon>
            }
            <span
              class="min-w-0 flex-1 text-neutral-600"
              [class.truncate]="!wrap()"
              >{{ option.label }}</span
            >

            <!-- The tick is the whole affordance where rows are taken rather than answered with. -->
            @if (multiple() && chosen(option)) {
              <mat-icon class="h-4! w-4! shrink-0 text-base! leading-4! text-primary-600">check</mat-icon>
            }
          </button>
        </li>
      }
    </guarantees-option-list>
  </div>
</ng-template>
